import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, unwrapEdges } from 'src/lib/graphql';

import { FRAGMENT_BRAND_VOICE, FRAGMENT_BRAND_VOICE_ASSETS } from './schema';

const QUERY = gql`
  query BrandVoicesAssets($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          associatedBrandVoices {
            ...BrandVoice
            ...BrandVoiceAssets
          }
        }
      }
    }
  }
  ${FRAGMENT_BRAND_VOICE}
  ${FRAGMENT_BRAND_VOICE_ASSETS}
`;

/**
 * Query brand voices assets for the current customer and workspace
 *
 * @param {object} params - query params
 * @param {string} params.customerId - ID of the customer
 * @param {string} params.workspaceId - ID of the workspace
 * @param {object} [options] - query options
 * @param {AbortSignal} [options.abortSignal] - abort signal
 * @returns {Promise<object[]>} - array of brand voices with their assets
 */
export const queryBrandVoicesAssets = async ({ customerId, workspaceId }, options) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { customerId, id: workspaceId },
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const workspaces = getSingleProp(result.data);
  const nodes = unwrapEdges(workspaces?.edges);
  return nodes?.[0]?.associatedBrandVoices;
};
